import logo from './logo.svg';
import './App.css';
import { Admin, Resource, ListGuesser, ShowGuesser, EditGuesser, defaultTheme, Login, CustomRoutes, usePermissions, LoginForm } from 'react-admin';
import { Route } from 'react-router-dom';
import { createTheme } from '@mui/material/styles';
import dataProvider, { baseUrl } from './dataProvider';
import Dashboard from "./Components/Dashboard";
import CampaignIcon from '@mui/icons-material/Campaign';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import PeopleIcon from '@mui/icons-material/People';
import ReceiptIcon from '@mui/icons-material/Receipt';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import FeedIcon from '@mui/icons-material/Feed';
import SettingsIcon from '@mui/icons-material/Settings';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import HelpIcon from '@mui/icons-material/Help';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import PolicyIcon from '@mui/icons-material/Policy';

import { UserCreate, UserEdit, UserList, UserShow } from "./Resources/Users";
import authProvider from './authProvider';
import { CommunityCreate, CommunityEdit, CommunityList, CommunityShow } from './Resources/Communities';
import { AnnouncementCreate, AnnouncementEdit, AnnouncementList } from './Resources/Announcements';
import { CoordinatingProgramCreate, CoordinatingProgramEdit, CoordinatingProgramList, CoordinatingProgramShow } from './Resources/CoordinatingPrograms';
import NmsLayout from './Components/NmsLayout';
import { FormCreate, FormEdit, FormList, FormShow } from './Resources/Forms';
import { FormEntryAverage, FormEntryList, FormEntryShow } from './Resources/FormEntries';
import { SettingEdit, SettingList, SettingShow } from './Resources/Settings';
import { FormStandardCreate, FormStandardEdit, FormStandardList, FormStandardShow } from './Resources/FormStandards';
import { FormKeyIndicatorCreate, FormKeyIndicatorEdit, FormKeyIndicatorList, FormKeyIndicatorShow } from './Resources/FormKeyIndicators';
import { FormIndicatorCreate, FormIndicatorEdit, FormIndicatorList, FormIndicatorShow } from './Resources/FormIndicators';
import { FormBaselineRequirementCreate, FormBaselineRequirementEdit, FormBaselineRequirementList, FormBaselineRequirementShow } from './Resources/FormBaselineRequirements';
import { CoordinatingProgramFormCreate, CoordinatingProgramFormEdit, CoordinatingProgramFormList, CoordinatingProgramFormShow } from './Resources/CoordinatingProgramForms';
import { HelpList, SupportRequestCreate, SupportRequestEdit, SupportRequestList, SupportRequestShow } from './Resources/SupportRequests';
import { AuditLogList, AuditLogShow, ReportList, ReportShow } from './Resources/Reports';

const theme = createTheme({
  ...defaultTheme,
  palette: {
      // https://www.tailwindshades.com/#color=189.7058823529412%2C100%2C40&step-up=12&step-down=8&hue-shift=0&name=cerulean&base-stop=5&v=1&overrides=e30%3D
      primary: {  main: '#00ABCC',  50: '#E0FAFF',  100: '#C2F5FF',  200: '#85EBFF',  300: '#47E1FF',  400: '#0AD7FF',  500: '#00ABCC',  600: '#0089A3',  700: '#00677A',  800: '#004452',  900: '#002229',  950: '#001114'},

      // https://www.tailwindshades.com/#color=85.97014925373135%2C53.6%2C50.98039215686274&step-up=10&step-down=11&hue-shift=0&name=sushi&base-stop=5&v=1&overrides=e30%3D
      secondary: {  main: '#8BC53F',  50: '#F5FAEF',  100: '#EAF4DC',  200: '#D2E8B5',  300: '#BADD8D',  400: '#A3D166',  500: '#8BC53F',  600: '#6D9D2F',  700: '#4F7222',  800: '#314615',  900: '#131B08',  950: '#040602'},

      // https://www.tailwindshades.com/#color=37.399103139013455%2C94.8936170212766%2C53.92156862745098&step-up=8&step-down=11&hue-shift=0&name=sun&base-stop=5&v=1&overrides=e30%3D
      orange: {  main: '#F9A51A',  50: '#FEEBCD',  100: '#FDE4B9',  200: '#FCD491',  300: '#FBC46A',  400: '#FAB542',  500: '#F9A51A',  600: '#D58706',  700: '#9F6404',  800: '#684203',  900: '#311F01',  950: '#160E01'},

      // https://www.tailwindshades.com/#color=52%2C100%2C50&step-up=10&step-down=11&hue-shift=0&name=school-bus-yellow&base-stop=5&v=1&overrides=e30%3D
      yellow: {  main: '#FFDD00',  50: '#FFFCE5',  100: '#FFF8CC',  200: '#FFF199',  300: '#FFEB66',  400: '#FFE433',  500: '#FFDD00',  600: '#C7AC00',  700: '#8F7C00',  800: '#574B00',  900: '#1F1B00',  950: '#030200'},


      white: {
        main: '#fff',
      },

      // https://www.tailwindshades.com/#color=220%2C8.936170212765955%2C46.07843137254902&step-up=8&step-down=11&hue-shift=0&name=pale-sky&base-stop=5&v=1&overrides=e30%3D
      gray: {
        primary: '#6B7280',
        50: '#CDD0D5',
        100: '#C2C5CC',
        200: '#ACB0BA',
        300: '#969BA7',
        400: '#7F8694',
        500: '#6B7280',
        600: '#515761',
        700: '#383C43',
        800: '#1E2024',
        900: '#050506',
        950: '#000000'
      },

  },

  /*
  typography: {
      // Use the system font instead of the default Roboto font.
      fontFamily: ['-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Arial', 'sans-serif'].join(','),
  },
  components: {
      MuiButton: { // override the styles of all instances of this component
          styleOverrides: {
              root: { // Name of the rule
                  color: 'white', // Some CSS
              },
          },
      },
  },
  */
});

const MyLoginPage = () => (
  <Login
      // A random image that changes everyday
      // backgroundImage="https://source.unsplash.com/random/1600x900/daily"
      backgroundImage=""
      // sx={{backgroundColor: '#fff'}}
      style={{backgroundColor: '#f9fafb', backgroundImage: 'none'}}
  >
    <LoginForm/>
    <div style={{textAlign: 'center', marginBottom: '4px', fontSize: '80%'}}>
      <a href={`${baseUrl}/forgot-password`} style={{color: '#444'}}>Reset Password</a>
    </div>
  </Login>
);

const App = () => (
  <Admin
    dataProvider={dataProvider}
    title={'Main Street Reporting Admin'}
    theme={theme}
    disableTelemetry
    authProvider={authProvider}
    layout={NmsLayout}
    dashboard={Dashboard}
    loginPage={MyLoginPage}
    requireAuth
  >
    {permissions => (<>

    {permissions.msa && (
    <Resource
      name="announcements"
      icon={CampaignIcon}
      list={AnnouncementList}
      edit={AnnouncementEdit}
      create={AnnouncementCreate}
    />
    )}

    <Resource
      name="communities"
      icon={LocationCityIcon}
      options={{label: 'Communities'}}
      list={CommunityList}
      show={CommunityShow}
      edit={CommunityEdit}
      create={CommunityCreate}
    />

    {permissions.msa && (
    <Resource
      name="coordinating-programs"
      icon={GroupWorkIcon}
      options={{label: 'Coordinating Programs'}}
      list={CoordinatingProgramList}
      show={CoordinatingProgramShow}
      edit={CoordinatingProgramEdit}
      create={CoordinatingProgramCreate}
    />
    )}

    {permissions.msa && (
    <Resource
      name="forms"
      icon={AssignmentIcon}
      options={{label: 'Forms'}}
      list={FormList}
      show={FormShow}
      edit={FormEdit}
      create={FormCreate}
    />
    )}
    <Resource
      name="coordinating-program-forms"
      icon={permissions.msa ? AssignmentLateIcon : AssignmentIcon}
      options={{label: permissions.msa ? 'CP Form Overrides' : 'Forms'}}
      list={CoordinatingProgramFormList}
      show={CoordinatingProgramFormShow}
      edit={CoordinatingProgramFormEdit}
      create={CoordinatingProgramFormCreate}
    />
    {/*
    <CustomRoutes>
      <Route path="/form-standards" action={({request}) => redirect('/forms')} />
    </CustomRoutes>
    */}
    <Resource
      name="form-baseline-requirements"
      options={{label: 'Form Baseline Requirements'}}
      // list={FormBaselineRequirementList}
      show={FormBaselineRequirementShow}
      edit={FormBaselineRequirementEdit}
      create={FormBaselineRequirementCreate}
    />
    <Resource
      name="form-standards"
      options={{label: 'Form Standards'}}
      // list={FormStandardList}
      show={FormStandardShow}
      edit={FormStandardEdit}
      create={FormStandardCreate}
    />
    <Resource
      name="form-key-indicators"
      options={{label: 'Form Key Indicators'}}
      // list={FormKeyIndicatorList}
      show={FormKeyIndicatorShow}
      edit={FormKeyIndicatorEdit}
      create={FormKeyIndicatorCreate}
    />
    <Resource
      name="form-indicators"
      options={{label: 'Form Indicators'}}
      // list={FormIndicatorList}
      show={FormIndicatorShow}
      edit={FormIndicatorEdit}
      create={FormIndicatorCreate}
    />

    <Resource
      name="form-entries"
      icon={FeedIcon}
      options={{label: 'Form Entries'}}
      list={FormEntryList}
      show={FormEntryShow}
      // edit={FormEdit}
      // create={FormEntryCreate}
    />
    <CustomRoutes>
      <Route path="/form-entries/average" element={<FormEntryAverage/>} />
    </CustomRoutes>

    <Resource
      name="users"
      icon={PeopleIcon}
      // list={ListGuesser}
      list={UserList}
      show={UserShow}
      edit={UserEdit}
      create={UserCreate}
    />

    <Resource
      name="support-requests"
      icon={HelpCenterIcon}
      options={{label: 'Support Requests'}}
      // list={ListGuesser}
      list={SupportRequestList}
      // show={SupportRequestShow}
      edit={SupportRequestEdit}
      create={SupportRequestCreate}
    />

    <Resource
      name="reports"
      icon={EqualizerIcon}
      options={{label: 'Reports'}}
      list={ReportList}
      // show={ReportShow}
    />
    <Resource
      name="audit-log"
      icon={PolicyIcon}
      options={{label: 'Audit Log'}}
      list={AuditLogList}
      show={AuditLogShow}
    />

    {permissions.msa && (
    <Resource
      name="settings"
      icon={SettingsIcon}
      options={{label: 'Settings'}}
      list={SettingList}
      show={SettingShow}
      edit={SettingEdit}
    />
    )}

    <Resource
      name="help"
      icon={HelpIcon}
      options={{label: 'Help'}}
      // list={ListGuesser}
      list={HelpList}
    />
  </>)}
  </Admin>
);

export default App;
